'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Body, _Component);

  function Body() {
    (0, _classCallCheck3.default)(this, Body);
    return (0, _possibleConstructorReturn3.default)(this, (Body.__proto__ || (0, _getPrototypeOf2.default)(Body)).apply(this, arguments));
  }

  (0, _createClass3.default)(Body, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          isStatic = _props.isStatic,
          isBasic = _props.isBasic,
          rest = (0, _objectWithoutProperties3.default)(_props, ['className', 'children', 'isStatic', 'isBasic']);

      var styles = require('./Body.scss');

      var classModifiers = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, styles['root--static'], isStatic), (0, _defineProperty3.default)(_cx, className + '--static', className && isStatic), (0, _defineProperty3.default)(_cx, styles['root--basic'], isBasic), (0, _defineProperty3.default)(_cx, className + '--basic', className && isBasic), _cx));

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, rest, { className: (0, _classnames2.default)(className, styles.root, classModifiers) }),
        children
      );
    }
  }]);
  return Body;
}(_react.Component), _class.propTypes = {
  isStatic: _react.PropTypes.bool,
  isBasic: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
}, _temp);
exports.default = Body;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Body/Body.jsx
// module id = 1601
// module chunks = 0